// Global Types
import type {
  $Translate,
} from 'common.language';

// Global Components
import * as React from 'react';

// Types
type $OptionalProps = {
  className?: string;
};

type $Props = $OptionalProps & $Translate & {
  value: number;
};

const ThQtyView = function ({
  className,
  t,
  value,
}: $Props) {
  return (
    <th className={`${className || ''} text-right`}>
      <span>
        {`${t('Qty.')}: `}
      </span>
      <span className={'text-muted'}>
        {value}
      </span>
    </th>
  );
};

ThQtyView.defaultProps = {
  className: undefined,
};

export default ThQtyView;
